import { render, staticRenderFns } from "./RenameFolder.vue?vue&type=template&id=0c0564f0&scoped=true"
import script from "./RenameFolder.vue?vue&type=script&lang=js"
export * from "./RenameFolder.vue?vue&type=script&lang=js"
import style0 from "./RenameFolder.vue?vue&type=style&index=0&id=0c0564f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0564f0",
  null
  
)

export default component.exports